import {
  type FilterableTaxon,
  type PageType,
  type Review,
  type HighlightReview,
  Page
} from '@/types/models'
import { isLocationPageType } from '../useCases/pageTypeCheck'
import type { PrimaryFocus } from '../primaryFocus/constant'
import { isNonEmptyArray, isNonEmptyString } from '@/utils/checks'
import { filterReviewsForLocationPages } from './filterReviewsForLocationPages'

export const MINIMUM_REVIEWS = 3

const PAGETYPES_TO_FILTER = [
  Page.LOCATION,
  Page.CONDITION,
  Page.FACET_LOCATION
] as PageType[]

export const filterReviewsByTermOrPrimaryFocus = ({
  reviews,
  filterableTaxonomies,
  pageType,
  primaryFocus,
  title
}: {
  reviews: HighlightReview[]
  filterableTaxonomies: FilterableTaxon[]
  primaryFocus?: PrimaryFocus
  pageType: PageType
  title: string
}): Review[] => {
  if (
    !PAGETYPES_TO_FILTER.includes(pageType) ||
    !isNonEmptyArray(filterableTaxonomies) ||
    !isNonEmptyString(primaryFocus)
  ) {
    return reviews
  }

  if (isLocationPageType(pageType)) {
    return filterReviewsForLocationPages({
      reviews,
      filterableTaxonomies,
      pageType,
      primaryFocus
    })
  }

  return reviews.filter(
    (review: HighlightReview) =>
      isNonEmptyArray(review.conditions_treated) &&
      review.conditions_treated.includes(title)
  )
}
